import { createMuiStyles } from '../../utils/mui';

export const newsCardStyles = createMuiStyles({
  card: {
    textDecoration: 'none',
    display: 'block',
    color: 'inherit',
    '&:hover, &:focus': {
      h3: {
        color: 'primary.main',
      },
    },
  },
  image: {
    display: 'block',
    width: 1,
    height: '20rem',
    objectFit: 'cover',
    borderRadius: 2,
    bgcolor: 'grey.50',
    border: 1,
    borderColor: 'grey.50',
    mt: 0.5,
  },
});
